<template lang="pug">
  div.container.mx-auto.px-6.text-center
    .div.w-20.border-t.border-acn-green.mx-auto
    page-menu
    
    div.max-w-xl.mx-auto
      div(v-for="update of updates" :key='update.id' ).my-4
        p.font-bold {{timeFormat(update.postDate)}}
      
        a(v-if='(update.updateEntry.length || update.updatelink)' @click='clickUpdate(update)').underline.hover_text-acn-green.cursor-pointer.text-xl {{update.title}}
        p.text-xl(v-else) {{update.title}}
        
        div(v-dompurify-html="update.mainText" ).redactor
  
</template>

<script>
import gql from 'graphql-tag'
import { apiQL } from '@/api'
import moment from 'moment'

export default {
  name: 'Updates',
  data() {
    return {
      updates: null,
    }
  },
  created() {
    this.loadUpdates()
  },
  mounted() {
    document.body.className = 'bg-acn-green-light'
  },
  methods: {
    timeFormat(obj) {
      return moment(obj).format('DD.MM.YYYY')
    },
    clickUpdate(update) {
      if (update.updateEntry.length) {
        const entry = update.updateEntry[0]
        this.$router
          .push({
            name: 'item',
            params: { sectionHandle: entry.sectionHandle, slug: entry.slug },
          })
          .catch(() => {})
      }
      if (update.updatelink) {
        try {
          const url = new URL(update.updatelink)
          if ((window.location.origin, url.origin === window.location.origin)) {
            this.$router.push(url.pathname).catch(() => {})
          } else {
            window.open(update.updatelink, '_blank')
          }
        } catch (error) {
          window.open(update.updatelink, '_blank')
        }
      }
    },
    async loadUpdates() {
      this.loading = true

      try {
        const q = gql`
          query {
            entries(type: "update") {
              id
              title
              postDate
              ... on updates_update_Entry {
                updatelink
                updateEntry {
                  slug
                  sectionHandle
                }
                mainText
              }
            }
          }
        `
        const result = await apiQL(q)
        this.updates = result.data.entries
      } catch (error) {
        this.error = error
      }
      this.loading = false
    },
  },
  metaInfo() {
    const title = 'Nieuws'
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title,
      meta: [
        {
          vmid: 'og:title',
          content: title,
        },
      ],
    }
  },
}
</script>
